import { Drawer, Icon, LabeledValue, Layout, Link, Tag } from '@loadsmart/miranda-react'

import { type Carrier, type OpenDockWarehouseDetails } from '../../domain/Shipment'
import { SignUpStatusAccordion } from './SignupStatusAccordion'

export function WarehouseInstructions({
  isSignedUp,
  warehouseDetails,
  shipmentCarrier,
  setStep,
}: {
  isSignedUp: boolean
  warehouseDetails: OpenDockWarehouseDetails
  shipmentCarrier: Carrier
  setStep: (step: string) => void
}) {
  return (
    <>
      <Drawer.Body>
        <Layout.Stack gap="spacing-6">
          <Layout.Stack gap="spacing-4">
            <SignUpStatusAccordion shipmentCarrier={shipmentCarrier} isSignedUp={isSignedUp} />
            <Layout.Stack gap="spacing-2">
              <LabeledValue>
                <LabeledValue.Label>Warehouse</LabeledValue.Label>
                <LabeledValue.Value>{warehouseDetails?.name}</LabeledValue.Value>
              </LabeledValue>

              <Link href={warehouseDetails?.yardMapImg}>
                <Layout.Group gap="spacing-1" align="center">
                  Yard map
                  <Icon name="export" color={'color-text-link'} />
                </Layout.Group>
              </Link>

              <LabeledValue>
                <LabeledValue.Label>Amenities</LabeledValue.Label>
                <LabeledValue.Value>
                  {warehouseDetails.amenities.length > 0
                    ? warehouseDetails.amenities.map(amenity => (
                        <Tag key={amenity} variant="neutral" size="small">
                          {amenity}
                        </Tag>
                      ))
                    : '-'}
                </LabeledValue.Value>
              </LabeledValue>

              <LabeledValue>
                <LabeledValue.Label>PPE and other equipment</LabeledValue.Label>
                <LabeledValue.Value>
                  {warehouseDetails.ppeRequirements.length > 0
                    ? warehouseDetails.ppeRequirements.map(requirement => (
                        <Tag key={requirement} variant="neutral" size="small">
                          {requirement}
                        </Tag>
                      ))
                    : '-'}
                </LabeledValue.Value>
              </LabeledValue>

              <LabeledValue>
                <LabeledValue.Label>Instructions</LabeledValue.Label>
                <LabeledValue.Value
                  dangerouslySetInnerHTML={{ __html: warehouseDetails?.instructions }}
                />
              </LabeledValue>
            </Layout.Stack>
          </Layout.Stack>
        </Layout.Stack>
      </Drawer.Body>
      <Drawer.Actions>
        <Drawer.ActionTertiary onClick={() => setStep('already_scheduled')}>
          Enter Confirmation Number
        </Drawer.ActionTertiary>
        <Drawer.ActionPrimary onClick={() => setStep('schedule')}>Start</Drawer.ActionPrimary>
      </Drawer.Actions>
    </>
  )
}
